<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/agentstudio-screens.png" alt="Agent Studio">
      </div>
      <div class="intro-text">
        <p>
          <a href="https://www.agentstudio.com/" target="blank">Agent Studio</a> 
          needed a new look, with an easier to use/less cluttered interface, 
          for their thousands of users' control panel.
          This was the system their customers used to setup their own travel 
          agency websites, which enabled them to serve their own customers. 
          A user-centered design approach was paramount. 
          Having done extensive research to confirm the diversity of users, 
          devices, and bandwidth that would be accessing the site, as well as many rounds
          of wireframing and mockups, I was very proud when we finally unveiled the new design.
          This was the first Content Management System (CMS) site I have done, 
          but in the end, a design challenge is just another 
          design challenge... and I like challenges.
        </p>
        <ul>
          <li>UX</li>
          <li>UI</li>
          <li>Design</li>
          <li>Development</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <img src="../../assets/portfolio/agentstudio-1.jpg" alt="Agent Studio">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/agentstudio-scene-1.jpg" alt="Agent Studio">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/agentstudio-2.jpg" alt="Agent Studio">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/agentstudio-3.jpg" alt="Agent Studio">
      </div>
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>Worked and re-worked</h2>
        <p>
          This project had a large number of user needs, on top of the complete 
          interface overhaul I helped them completely re-work the user flow of 
          their system. Much of the work was spent mapping out the user 
          experience and flow of the interface. Countless hours were spent in 
          Adobe XD creating and recreating wireframes, 
          but I'm into that sort of thing.
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/adobe-xd.png" alt="adobe xd">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "agentstudio",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
